import { render, staticRenderFns } from "./AddPages.vue?vue&type=template&id=3b2b9dd2&scoped=true&"
import script from "./AddPages.vue?vue&type=script&lang=js&"
export * from "./AddPages.vue?vue&type=script&lang=js&"
import style0 from "./AddPages.vue?vue&type=style&index=0&id=3b2b9dd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2b9dd2",
  null
  
)

export default component.exports